<template>
    <div>
        <hr class="mb-3">
        <el-table
            :data="tableData">
            <el-table-column :label="'Scans this Month by User'" label-class-name="h5 text-center">

                <el-table-column
                prop="name"
                label="Name">
                </el-table-column>

                <el-table-column
                prop="count"
                label="Scan Count"
                >
                </el-table-column>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        props: ['row'],
        name: 'UserScansTable',
        data () {
            return {
                tableData: [],
            }
        },
        methods: {
                getTableData(){
                    axios.get('scan-report/scansByUser')
                        .then((res) => {
                            this.tableData = res.data.data;
                        })
                }
        },
        mounted() {
            this.getTableData();
        },
    };
</script>

<style scoped>

</style>